export default () => ({
    '& .ant-select': {
        minWidth: '7rem',
    },
});
